import { render, staticRenderFns } from "./LogBoxLink.vue?vue&type=template&id=9d9aa1b2&scoped=true&"
import script from "./LogBoxLink.vue?vue&type=script&lang=ts&"
export * from "./LogBoxLink.vue?vue&type=script&lang=ts&"
import style0 from "./LogBoxLink.vue?vue&type=style&index=0&id=9d9aa1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9aa1b2",
  null
  
)

export default component.exports